// removed by extract-text-webpack-plugin
module.exports = {"Section":"InfoBox__Section__3yNI5","Header":"InfoBox__Header__Uvnlk","Left":"InfoBox__Left__1ztt_","Icon":"InfoBox__Icon__1RVDc","Right":"InfoBox__Right__1yBuE","Content":"InfoBox__Content__3TKHM","RightTitle":"InfoBox__RightTitle__3OdFB"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/InfoBox/InfoBox.css
// module id = 931
// module chunks = 2